import { render, staticRenderFns } from "./feeRemindList.vue?vue&type=template&id=61a447d2&scoped=true"
import script from "./feeRemindList.vue?vue&type=script&lang=js"
export * from "./feeRemindList.vue?vue&type=script&lang=js"
import style0 from "./feeRemindList.vue?vue&type=style&index=0&id=61a447d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a447d2",
  null
  
)

export default component.exports